import styled from 'styled-components'
import { NavLink } from 'react-router'

export const Navbar = styled.div<{ isShown: boolean }>`
  display: ${(props) => (!props.isShown && props.theme.isMobile ? 'none' : 'flex')};
  position: ${(props) => (props.theme.isMobile ? 'absolute' : 'block')};
  width: ${(props) => (props.theme.isMobile ? '100vw' : '15vw')};
  height: 100%;
  min-width: 200px;
  max-width: ${(props) => (props.theme.isMobile ? '100vw' : '300px')};
  background-color: ${(props) => props.theme.colors.neutralColor900};
  color: ${(props) => props.theme.colors.white};
  flex-direction: column;
  justify-content: space-between;
  z-index: 9999;
`
export const NavHeader = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.colors.whiteAlpha10};
  display: flex;
  align-items: center;
`
export const ResponsiveHeader = styled.div`
  position: fixed;
  display: flex;
  width: 100vw;
  height: 6vh;
  min-height: 3rem;
  align-items: center;
  padding: 0.2rem;
  background-color: ${(props) => props.theme.colors.neutralColor900};
  z-index: 9998;
`
export const MenuButton = styled.button`
  position: relative;
  font-size: 1.5rem;
  padding: 1rem;
  background-color: transparent;
  border: none;
  outline: none;
  color: ${(props) => props.theme.colors.white};
`

export const HelperSpan = styled.span`
  flex: 0;
  padding: 1rem;
`

export const LogoSearch = styled.div`
  display: flex;
  flex-direction: column;
`

export const Logo = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  & img {
    width: ${(props) => (props.theme.isMobile ? '40%' : '100%')};
    height: auto;
  }
`
export const SearchBar = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 1rem;
`

export const LinksWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const StyledLink = styled(NavLink)<{ $active: boolean; $isAccessGranted: boolean }>`
  text-decoration: none;
  color: ${(props) =>
    props.$active ? props.theme.colors.primaryColor500 : props.theme.colors.white};
  background-color: ${(props) => props.theme.colors.transparent};
  width: 100%;
  padding: 1rem;
  display: ${(props) => (props.$isAccessGranted ? 'flex' : 'none')};
  &:hover {
    background-color: ${(props) => props.theme.colors.neutralColor700};
  }
`

export const StyledExternalLink = styled('a')`
  text-decoration: none;
  color: ${(props) => props.theme.colors.white};
  background-color: ${(props) => props.theme.colors.transparent};
  width: 100%;
  padding: 1rem;
  display: flex;
  &:hover {
    background-color: ${(props) => props.theme.colors.neutralColor700};
  }
`

export const UserWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  padding: 2rem 1rem;
`
export const NavbarTop = styled.div`
  display: flex;
  flex-direction: column;
`

export const UserName = styled.div`
  font-weight: 900;
  font-size: 1.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
`
export const LogoutButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 0.5rem 1rem;
  color: ${(props) => props.theme.colors.white};
  font-size: ${(props) => props.theme.sizes.h2};
  cursor: pointer;
  border-radius: 4px;
  &:hover {
    color: ${(props) => props.theme.colors.primaryColor500};
  }
  &:focus {
    outline: none;
    background-color: ${(props) => props.theme.colors.neutralColor500};
  }
`

export const IconMenu = styled.div`
  display: flex;
  width: 1.5rem;
  justify-content: center;
`

export const TitleMenu = styled.div`
  padding-left: 0.2rem;
`
